import React from 'react';
import {
  AutocompleteElement,
  AutocompleteElementProps,
  ControllerProps,
  FieldPath,
  FieldValues,
  SelectElement,
  SelectElementProps,
  SwitchElement,
  SwitchElementProps,
  TextFieldElement,
  TextFieldElementProps
} from 'react-hook-form-mui';
import dayjs, {Dayjs} from 'dayjs';
import {DateTimePickerElement, DateTimePickerElementProps} from 'react-hook-form-mui/date-pickers';

export const TextInput = (props: TextFieldElementProps & {minLength?: number}) => {
  const {minLength, label, ...rest} = props;
  const rules = React.useMemo(() => {
    const value: ControllerProps<FieldValues>['rules'] = {};
    if (minLength) {
      value.minLength = {value: minLength, message: `${label} should be at least ${minLength} characters`};
    }

    return value;
  }, [minLength, label]);
  return <TextFieldElement size="small" margin="normal" label={label} rules={rules} {...rest} />;
};

export const SelectInput = (props: SelectElementProps<FieldValues>) => <SelectElement size="small" margin="normal" {...props} />;

export const SwitchInput = (props: Omit<SwitchElementProps<FieldValues>, 'ref'>) => <SwitchElement sx={{width: '100%'}} {...props} />;

export const DateTimePickerInput = (props: DateTimePickerElementProps<FieldValues, FieldPath<FieldValues>, Dayjs> & {fullWidth?: boolean}) => {
  const {fullWidth = false, ...rest} = props;
  return <DateTimePickerElement inputProps={{size: 'small', margin: 'normal', fullWidth}} defaultValue={dayjs()} {...rest} />;
};

export const AutocompleteInput = <T,>(props: AutocompleteInputProps<T>) => {
  const {fullWidth = false, ...rest} = props;
  return <AutocompleteElement matchId autocompleteProps={{size: 'small', fullWidth}} textFieldProps={{size: 'small', margin: 'normal'}} {...rest} />;
};

export type AutocompleteInputProps<T> = AutocompleteElementProps<T, boolean | undefined, boolean | undefined, boolean | undefined> & {
  fullWidth?: boolean;
};
